let productList = [
  // 付帅云喇叭 FY200
  [
    {
      isReverse: false,
      title: ['付帅云喇叭FY200'],
      h4: [
        '2G/WIFI/4G联网，联网更稳定。',
        '高容量电池，超长待机时间。',
        'AI智能文字转语音播报，什么都能播。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/service/service_f_01.png'
    },
    {
      isReverse: true,
      title: ['2G/WIFI/4G联网，联网更稳定'],
      h4: [
        '脱离手机使用，网络自动切换，',
        '没有WIFI也能用。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/service/service_f_02.png'
    },
    {
      isReverse: false,
      title: ['高容量电池，超长待机时间'],
      h4: [
        '自带充电电池，充电用两天，',
        '没有电源的地方也能用。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/service/service_f_03.png'
    },
    {
      isReverse: true,
      title: ['AI智能文字转语音，什么都能播'],
      h4: [
        '内置TTS离线转换，无需网络合成，',
        '速度更快，实时文字转语音播报，',
        '想播什么，就播什么。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/service/service_f_04.png'
    }
  ],
  // 付帅云打印 FY070
  [
    {
      isReverse: false,
      title: ['付帅云打印FY070'],
      h4: [
        '随时随地，',
        '满足你的所有打印需求。',
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/service/service_e_01.png'
    },
    {
      isReverse: true,
      title: ['WIFI联网，远程打印'],
      h4: [
        '打印机通过WIFI连接网络，云端推送打印。',
        '自助点餐、自建外卖、扫码购等软件必备打印机'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/service/service_e_02.png'
    },
    {
      isReverse: false,
      title: ['多种供电模式'],
      h4: [
        '门店用220V（伏），餐车用12V（伏），',
        '多种供电模式，满足您的多种需求。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/service/service_e_03.png'
    },
    {
      isReverse: true,
      title: ['充电电池版本研发中'],
      h4: [
        '充电电池版本研发中，有需求可联系客服详谈。',
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/service/service_e_04.png'
    }
  ],
]

export default productList



// WEBPACK FOOTER //
// ./src/assets/conf/service.js